/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { Button, Switch, Tooltip, Empty, Card, Row, Col, Tag } from 'antd'
import { FaUserPlus, FaUser, FaPhone, FaEnvelope, FaTrash } from 'react-icons/fa'

import { IndicationModal } from '../Modals/IndicationModal';
import { useState } from 'react';
import { phoneMask } from '~/helpers/masks';
import { WhatsappIcon } from '~/icons/WhatsappIcon';
import { WhatsappLink } from './styles';


export var IndicationsTab = function(props) {
  var setIndications = props.setIndications;
  var indications = props.indications;
  var leadChoseNotToIndicate = props.leadChoseNotToIndicate;
  var setLeadChoseNotToIndicate = props.setLeadChoseNotToIndicate;

  var [isModalVisible, setIsModalVisible] = useState(false);

  var handleRemoveIndication = function(index) {
    var newIndications = indications.filter(function(_, i) {
      return i !== index;
    });
    setIndications(newIndications);
  };

  var renderIndicationCard = function(indication, index) {
    var phoneWithOnlyNumber = indication.phone ? indication.phone.replace(/\D/g, '') : '';

    return (
      <Card
        key={index}
        size="small"
        style={{
          marginBottom: 12,
          border: '1px solid #d9d9d9',
          borderRadius: 8,
          background: '#fff'
        }}
        bodyStyle={{ padding: '12px 16px' }}
      >
        <Row gutter={16} align="middle">
          <Col flex="40px">
            <div style={{
              width: 36,
              height: 36,
              borderRadius: '50%',
              background: '#e6f7ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <FaUser style={{ color: '#1890ff', fontSize: 16 }} />
            </div>
          </Col>
          <Col flex="auto">
            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4 }}>
              {indication.name}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
              {indication.phone && (
                <span style={{ display: 'flex', alignItems: 'center', fontSize: 13, color: '#666', marginRight: 16 }}>
                  <FaPhone style={{ marginRight: 6, fontSize: 12 }} />
                  {phoneMask(indication.phone)}
                  <Tooltip title="Ir para o Whatsapp">
                    <WhatsappLink href={'https://wa.me/55' + phoneWithOnlyNumber} target="_blank" style={{ marginLeft: 6 }}>
                      <WhatsappIcon />
                    </WhatsappLink>
                  </Tooltip>
                </span>
              )}
              {indication.email && (
                <span style={{ display: 'flex', alignItems: 'center', fontSize: 13, color: '#666', marginRight: 16 }}>
                  <FaEnvelope style={{ marginRight: 6, fontSize: 12 }} />
                  {indication.email}
                </span>
              )}
            </div>
          </Col>
          <Col>
            <Tooltip title="Remover indicação">
              <Button
                type="link"
                size="small"
                style={{ color: '#ff4d4f' }}
                onClick={function() { handleRemoveIndication(index); }}
              >
                <FaTrash />
              </Button>
            </Tooltip>
          </Col>
        </Row>
      </Card>
    );
  };

  return (
    <>
      {/* Indications Section */}
      <Card
        size="small"
        style={{
          border: '1px solid #d9d9d9',
          borderRadius: 8,
          overflow: 'hidden'
        }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{
          background: '#fafafa',
          padding: '12px 16px',
          borderBottom: '1px solid #d9d9d9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <span style={{ fontWeight: 600, fontSize: 15, display: 'flex', alignItems: 'center' }}>
            <FaUserPlus style={{ marginRight: 8 }} />
            Indicações
            {indications.length > 0 && (
              <Tag color="blue" style={{ marginLeft: 8 }}>{indications.length}</Tag>
            )}
          </span>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title="Marcar se o cliente não deseja indicar">
              <span style={{ marginRight: 8, fontSize: 13, color: '#666' }}>Não indica</span>
            </Tooltip>
            <Switch
              size="small"
              checked={leadChoseNotToIndicate}
              onChange={function(isChecked) { setLeadChoseNotToIndicate(isChecked); }}
              style={{ marginRight: 12 }}
            />
            <Button
              type="primary"
              size="small"
              icon="plus"
              onClick={function() { setIsModalVisible(true); }}
              disabled={leadChoseNotToIndicate}
            >
              Adicionar
            </Button>
          </div>
        </div>

        <div style={{ padding: 16 }}>
          {leadChoseNotToIndicate ? (
            <Empty
              description={
                <span style={{ color: '#999' }}>
                  Cliente optou por não fazer indicações
                </span>
              }
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              style={{ padding: '24px 0' }}
            />
          ) : indications.length === 0 ? (
            <Empty
              description="Nenhuma indicação cadastrada"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              style={{ padding: '24px 0' }}
            >
              <Button
                type="primary"
                icon="plus"
                onClick={function() { setIsModalVisible(true); }}
              >
                Adicionar primeira indicação
              </Button>
            </Empty>
          ) : (
            <div>
              {indications.map(function(indication, index) {
                return renderIndicationCard(indication, index);
              })}
            </div>
          )}
        </div>
      </Card>

      <IndicationModal
        isVisible={isModalVisible}
        closeModal={function() { setIsModalVisible(false); }}
        setIndications={setIndications}
        indications={indications}
      />
    </>
  );
};
